import { render } from "./ResetPage.vue?vue&type=template&id=1b82a445&scoped=true"
import script from "@/assets/js/reset.js?vue&type=script&defer=true&lang=js&external"
export * from "@/assets/js/reset.js?vue&type=script&defer=true&lang=js&external"

import "@/assets/css/reset.css?vue&type=style&index=0&id=1b82a445&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b82a445"]])

export default __exports__